import {ChangeDetectorRef, Component, Inject, ViewChild, ViewContainerRef} from '@angular/core';
import {DetailPopup} from '../../../mapping-classes/detail-popup';
import * as DetailTable from '../../../table-lib';
import {DomService} from "../../../../../../services/dom-service/dom.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {CreditorListingsComponent} from "../../../detail-table/account-direct-debit-listings/creditor-listings-table/creditor-listings.component";
import {MandateListingsComponent} from "../../../detail-table/account-direct-debit-listings/mandate-listings-table/mandate-listings.component";
import {RestrictedMandateListingsComponent} from "../../../detail-table/account-direct-debit-listings/restricted-mandate-listings-table/restricted-mandate-listings.component";

@Component({
  selector: 'app-detail-table',
  templateUrl: './account-direct-debit-listings.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})
export class AccountDirectDebitListingsComponent implements DetailPopup {

  @ViewChild('creditorListingsTable', {read: ViewContainerRef}) creditorListingsTableContainer: ViewContainerRef;
  @ViewChild('mandateListingsTable', {read: ViewContainerRef}) mandateListingsTableContainer: ViewContainerRef;
  @ViewChild('restrictedMandateListingsTable', {read: ViewContainerRef}) restrictedMandateListingsTableContainer: ViewContainerRef;

  errorText: string;
  restrictedData: boolean;
  title: string;
  data: any;
  hasData = true;
  tableInstance;
  tableComponent;
  showCreditorListingsTable: boolean;
  showMandateListingsTable: boolean;
  showRestrictedMandateListingsTable: boolean;
  showRestrictedCountryListings: boolean;

  constructor(private domService: DomService, private changeRef: ChangeDetectorRef,
              public dialogRef: MatDialogRef<AccountDirectDebitListingsComponent>,
              @Inject(MAT_DIALOG_DATA) public inputData: any) {
    this.title = "Blokkadelijst incassanten, machtigingen en landen";

    if (inputData.listOfError && inputData.listOfError.length !== 0) {
      this.createErrorMessage(inputData);
      this.hasData = false;
    } else if (inputData.detailsViewObject) {
      this.data = inputData;
    }
  }

  ngAfterViewInit() {
    this.addValues(this.data);
    this.changeRef.detectChanges();
  }

  close() {
    this.dialogRef.close();
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F016') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.title = 'Blokkadelijst incassanten, machtigingen en landen';
        this.errorText = 'Geen data gevonden.';
      }
    }
  }

  addValues(response) {
    if (!response) {
      return;
    }
    const detailsViewObject = response.detailsViewObject || {};
    if(detailsViewObject.creditorListings) {
      this.showCreditorListingsTable = true;
      this.createCreditorListingsTable(detailsViewObject);
    }
    if(detailsViewObject.mandateListings) {
      this.showMandateListingsTable = true;
      this.createMandateListingsTable(detailsViewObject);
    }
    if(detailsViewObject.restrictedMandateListings) {
      this.showRestrictedMandateListingsTable = true;
      this.createRestrictedMandateListingsTable(detailsViewObject);
    }
    if(detailsViewObject.restrictedCountryListings) {
      if(detailsViewObject.restrictedCountryListings.length > 0) {
        this.showRestrictedCountryListings = true;
      }
    }

  }

  private createCreditorListingsTable(detailsViewObject) {
    this.changeRef.detectChanges();
    this.tableInstance = new DetailTable['CreditorListings'](detailsViewObject.creditorListings);
    if (!this.creditorListingsTableContainer) {
      return null;
    }
    const viewRef = this.domService.addComponentToDOM(CreditorListingsComponent, this.creditorListingsTableContainer);
    const tableComponentToReturn = viewRef.instance as CreditorListingsComponent;
    this.tableComponent = this.setTableValues(tableComponentToReturn);
  }

  private createMandateListingsTable(detailsViewObject) {
    this.changeRef.detectChanges();
    this.tableInstance = new DetailTable['MandateListings'](detailsViewObject.mandateListings);
    if (!this.mandateListingsTableContainer) {
      return null;
    }
    const viewRef = this.domService.addComponentToDOM(MandateListingsComponent, this.mandateListingsTableContainer);
    const tableComponentToReturn = viewRef.instance as MandateListingsComponent;
    this.tableComponent = this.setTableValues(tableComponentToReturn);
  }

  private createRestrictedMandateListingsTable(detailsViewObject) {
    this.changeRef.detectChanges();
    this.tableInstance = new DetailTable['RestrictedMandateListings'](detailsViewObject.restrictedMandateListings);
    if (!this.restrictedMandateListingsTableContainer) {
      return null;
    }
    const viewRef = this.domService.addComponentToDOM(RestrictedMandateListingsComponent, this.restrictedMandateListingsTableContainer);
    const tableComponentToReturn = viewRef.instance as RestrictedMandateListingsComponent;
    this.tableComponent = this.setTableValues(tableComponentToReturn);
  }

  private setTableValues(componentToReturn) {
    componentToReturn.errorText = this.tableInstance.errorText;
    componentToReturn.showTable = (componentToReturn.errorText === null || componentToReturn.errorText === undefined);
    componentToReturn.restrictedData = this.restrictedData;
    componentToReturn.tableColumns = this.tableInstance.rowHeaders;
    componentToReturn.tableData = this.tableInstance.rowData;
    return componentToReturn;
  }
}
